import DetectableOverflow from 'react-detectable-overflow';
import styled from 'styled-components';

export const Text = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

interface IOverflow {
  color?: string;
}

export const Overflow = styled(DetectableOverflow)<IOverflow>`
  color: ${({ color }) => color || '#1b203a'};
  font-size: 14px;
  font-weight: 400;
`;
